import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/ionicons.min.css';
import './assets/css/line-awesome/css/line-awesome.min.css';
import './assets/css/cryptocoins/css/cryptocoins.css';
import './assets/css/cryptocoins/css/cryptocoins-colors.css';
import './assets/css/font-awesome/css/font-awesome.min.css';
import './assets/css/material-design-iconic-font/css/materialdesignicons.min.css';
import './assets/scss/style.scss';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
